import { useTableLayoutTemplateContext } from '@aibees/shared/features/advance-table/components/table-layout-modifier-dialog/context';
import useTransferListStore from '@aibees/shared/features/transfer-list/store/transfer-list-store';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import {
  Button,
  Stack,
  Switch,
  TextField,
  TextFieldProps,
  Typography,
} from '@mui/material';
import React, { memo, useRef } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { TableLayoutTemplateCreateFormProps as Props } from './types';

export const TableLayoutTemplateCreateForm = memo(
  ({ className, managementPopoverState, transferListPopoverState }: Props) => {
    const store = useTransferListStore();
    const { isPrivate, setTemplateName, templateName } =
      useTableLayoutTemplateContext();

    const disabled = useBoolean(true);
    const ref = useRef<HTMLButtonElement | null>(null);

    const handleCreate = () => {
      if (ref.current) transferListPopoverState.onOpen(ref.current);
      store.setExcluded([]);
    };

    const handleCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
      isPrivate.setValue(e.target.checked);
    };

    const handleChange: TextFieldProps['onChange'] = (e) => {
      setTemplateName(e.target.value);
      if (ref.current) {
        if (e.target.value) disabled.onFalse();
        else disabled.onTrue();
      }
    };

    return (
      <Styled.Wrapper
        className={classnames('TableLayoutTemplateCreateForm', className)}
        sx={SX.root}
      >
        <Stack gap={1}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            gap={17}
          >
            <Typography sx={SX.title}>Create New Layout Templates</Typography>
            <Stack direction="row" alignItems="center">
              <Typography sx={SX.label}>Share</Typography>
              <Switch onChange={handleCheck} />
              <Typography sx={SX.label}>Private</Typography>
            </Stack>
          </Stack>
          <Stack direction="row" gap={0.5}>
            <TextField
              size={'small'}
              sx={SX.textfield}
              placeholder="Enter Template Name"
              onChange={handleChange}
              value={templateName}
            />
            <Button
              sx={SX.button}
              color="primary"
              variant="contained"
              onClick={handleCreate}
              ref={ref}
              disabled={disabled.value}
            >
              Create Template
            </Button>
          </Stack>
        </Stack>
      </Styled.Wrapper>
    );
  }
);

TableLayoutTemplateCreateForm.displayName = 'TableLayoutTemplateCreateForm';
